import React, {useContext, useEffect, useState} from "react";
import Select from "react-select";
import {AthleteContext} from "../../context/Athele/AthleteContext";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AuthContext} from "../../context/AuthContext";
import api from "../../services/api";
import ICollections from "../../interfaces/IWeaponCollections";

export default function PresidentForm() {
    const {active, memberNumber, setMemberNumber,
        membershipDate, memberActivity,  setMembershipDate,
        disaffiliationDate, setDisaffiliationDate,
        membershipType, setMembershipType,setMemberActivity
        } = useContext(AthleteContext)

    const [arrayWeaponCollection, setArrayWeaponCollection] = useState([] as any)

    async function merberActivitys() {
        const response = await api.get(`/api/weaponCollections`)
        const result = await response
        return setArrayWeaponCollection(
            await result.data.map((collection:ICollections) => ({
                value: collection.id,
                label: collection.description
            })),
        )
    }

    useEffect(() => {
        merberActivitys()
    },  [])

    const { authUser } = useContext(AuthContext)

    return (
        <>
            <div className={"col-md-4"}>
                <label htmlFor="membership_type" className="form-label">Tipo filiação<i
                    className="text-danger"> *</i></label>
                <Select
                    defaultValue={{label: 'Individual', value: 'I'}}
                    options={[{label: 'Individual', value: 'I'}, {label: 'Familiar', value: 'F'}, {label: 'Visitante', value: 'V'}]}
                    value={[{label: 'Individual', value: 'I'}, {label: 'Familiar', value: 'F'}, {
                        label: 'Visitante',
                        value: 'V'
                    }].find(option => option.value == membershipType)}
                    name='membership_type'
                    isDisabled={authUser?.role === 'athlete'}
                    id='membership_type'
                    onChange={(data: any) => {
                        setMembershipType(data.value)
                    }}
                />
            </div>

            {(membershipType != 'V') &&
            <>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <div className={"col-md-4"}>
                        <label htmlFor="associationDate" className="form-label">Data de filiação <i
                            className="text-danger"> *</i></label>
                        <DatePicker className={"form-control sadate"}
                                    disabled={authUser?.role === 'athlete'}
                                    value={membershipDate}
                                    onChange={evento => setMembershipDate(evento)}/>
                    </div>
                </LocalizationProvider>

                <div className={"col-md-4"}>
                    <label htmlFor="quantity_shots" className="form-label">Número de sócio <i
                        className="text-danger"> *</i></label>
                    <input type="number" disabled={authUser?.role === 'athlete'} className="form-control" id="quantity_shots" placeholder="0"
                           onChange={evento => setMemberNumber(evento.target.value)} value={memberNumber}/>
                </div>
            </>
            }

            <div className="col-md-4">
                <label htmlFor="menber_activity" className="form-label">Atividade<i
                    className="text-danger"> *</i></label>
                <Select
                    isMulti
                    options={arrayWeaponCollection}
                    name='menber_activity'
                    id='menber_activity'
                    onChange={(data: any) => {
                        setMemberActivity(data)
                    }}
                    noOptionsMessage={() => 'Nenhum registro encontrado'}
                    value={memberActivity || ''}
                    placeholder='Atividade do socio'
                />
            </div>

            {(authUser?.role !== 'athlete' && !active) &&
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <div className="col-md-4">
                        <label htmlFor="disaffiliation_date" className="form-label">Data de desfiliação <i
                            className="text-danger"> *</i></label>
                        <DatePicker className={"form-control sadate"}
                                    value={disaffiliationDate}
                                    onChange={evento => setDisaffiliationDate(evento)}/>
                    </div>
                </LocalizationProvider>
            }
        </>
    );
}

